import { FC, useState, useEffect } from 'react';

import { EsModule } from '~src/types';

interface SvgImport {
  content: string;
  id: string;
  node: HTMLElement;
  viewBox: string;
}

interface Props {
  name: 'loopPicture' | 'loopCongrats';
}

const SvgPicture: FC<Props> = props => {
  const [svgIcon, setSvgIcon] = useState<SvgImport>();
  useEffect(() => {
    getLoopPicture();
  }, []);

  const getLoopPicture = async () => {
    let icon: EsModule<SvgImport>;
    switch (props.name) {
      case 'loopPicture':
        icon = await import(/* webpackPrefetch: true */ '../images/loopPicture.svg');
        break;
      case 'loopCongrats':
        icon = await import(/* webpackPrefetch: true */ '../images/loopCongrats.svg');
        break;
      default:
        icon = await import(/* webpackPrefetch: true */ '../images/loopPicture.svg');
    }
    setSvgIcon(icon.default);
  };

  return svgIcon ? <img width="300" height="auto" src={`${svgIcon}`} /> : null;
};

export default SvgPicture;
